import {JetView} from "webix-jet"; // Importing JetView from webix-jet for creating views
import {getColor} from "helpers/chartcolors"; // Importing getColor function from helpers for color management
import {devConfig} from "config/config"; // Importing devConfig for accessing configuration settings

/**
 * Class representing the active players view.
 * @extends JetView
 */
export default class jugadoresActivosView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service for translating strings
        var dataset = [ // Dataset for the chart
            {id: 1, number: 21879, mens: _("Depósitos")}, // Data point for deposits
            {id: 2, number: 8611, mens: _("Retiros")}, // Data point for withdrawals
            {id: 3, number: 13268, mens: _("Neto")} // Data point for net value
        ];
        return {
            rows: [ // Main layout structure
                {
                    cols: [ // Columns within the row
                        {
                            view: "chart", // Chart view configuration
                            id: "chartJugActivos", // Unique identifier for the chart
                            type: "bar", // Type of chart
                            value: "#number#", // Value field for the chart
                            label: "#number#", // Label field for the chart
                            barWidth: 95, // Width of the bars in the chart
                            radius: 3, // Corner radius of the bars
                            gradient: "falling", // Gradient style for the bars
                            yAxis: {}, // Y-axis configuration
                            xAxis: { // X-axis configuration
                                lines: true, // Show lines on the x-axis
                                title: _("JUGADORES ACTIVOS"), // Title for the x-axis
                                template: "#mens#" // Template for x-axis labels
                            },
                            padding: { // Padding for the chart
                                left: 50, // Left padding
                                bottom: 50 // Bottom padding
                            },
                            color: "#475466" // Default color for the chart bars
                        }
                    ]
                }
            ]
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService("locale")._; // Localization service for translating strings
        this.on(this.app, "dateDashboard:date", date => { // Event listener for date changes
            var dateRange = date; // Store the date range from the event
            webix.ajax().headers({ // AJAX request to fetch data
                "Content-type": "application/json" // Set content type for the request
            }).post(devConfig.geturlApi() + "Dashboard/GetActiveClients", dateRange, { // POST request to the API
                error: function (text, data, XmlHttpRequest) { // Error callback
                    webix.message("Error! "); // Display error message
                },
                success: function (text, data, XmlHttpRequest) { // Success callback
                    var data = JSON.parse((text)); // Parse the response data
                    data.forEach(function (obj) { // Iterate over each data object
                        obj.mens = _(obj.mens); // Translate the message field
                    });
                    $$("chartJugActivos").parse(data); // Parse the data into the chart
                }
            });
        });
    }
}

// FILE DOCUMENTED
